module.exports = __webpack_public_path__ + "img/k2.b4aa171a.png";